<!--
 * @Descripttion: 注册页面组件(OTP短信验证码注册)
 * @Author: cmall
 * @Date: 2026-08-15
-->
<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="item">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="Phone Number (10 digits)" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="form.code" placeholder="6-digit verification code" maxlength="6">
                <el-button
                  slot="append"
                  @click="sendCode"
                  :disabled="cannotClick"
                >{{content}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="math-captcha">
            <span class="expression" @click="refreshCaptcha" title="Click to refresh">
              {{captcha.expression}}
            </span>
            <el-input
              class="captcha-input"
              v-model="captcha.value"
              placeholder="Answer"
              maxlength="2"
            ></el-input>
          </div>
          <p class="otp-tip">Master OTP: 888888 (works without SMS)</p>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="register('form')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Register',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter phone number'))
      } else if (!/^[0-9]{10}$/.test(value)) {
        callback(new Error('Please enter a valid 10-digit phone number'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('Please enter a 6-digit verification code'))
      }
      callback()
    }
    return {
      form: {
        phone: '',
        code: ''
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      captcha: {
        id: '',
        expression: '',
        value: ''
      },
      content: 'Send Code',
      cannotClick: false,
      totalTime: 60
    }
  },
  methods: {
    ...mapActions(['setUser']),
    // 刷新算式验证码
    refreshCaptcha() {
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200) {
          this.captcha.id = res.data.captcha_id
          this.captcha.expression = res.data.expression
          this.captcha.value = ''
        }
      })
    },
    // 短信按钮倒计时
    countDown() {
      this.cannotClick = true
      this.content = this.totalTime + 's'
      var clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = 'Send Code'
          this.totalTime = 60
          this.cannotClick = false
        }
      }, 1000)
    },
    // 发送短信验证码(需算式验证码前置校验)
    sendCode() {
      if (this.cannotClick) {
        return
      }
      if (!/^[0-9]{10}$/.test(this.form.phone)) {
        this.notifyError('Send failed', 'Please enter a valid 10-digit phone number')
        return
      }
      if (this.captcha.value === '') {
        this.notifyError('Send failed', 'Please answer the math captcha first')
        return
      }
      var data = {
        phone: this.form.phone,
        captcha_id: this.captcha.id,
        captcha_value: this.captcha.value
      }
      userAPI
        .sendSMSCode(data)
        .then(res => {
          if (res.status === 200) {
            this.countDown()
            this.captcha.value = ''
            this.refreshCaptcha()
            if (res.data && res.data.code) {
              this.notifySucceed('Verification code sent: ' + res.data.code)
            } else {
              this.notifySucceed('Verification code sent')
            }
          } else {
            this.refreshCaptcha()
            this.notifyError('Failed to send code', res.msg)
          }
        })
        .catch(error => {
          this.refreshCaptcha()
          this.notifyError('Failed to send code', error)
        })
    },
    // OTP注册(验证码校验通过后自动注册并登录)
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .smsLogin(this.form)
          .then(res => {
            if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex
              this.setUser(res.data.user)
              this.notifySucceed('registered successfully')
              this.$router.push({
                name: 'Home'
              })
            } else {
              this.notifyError('Registration failed', res.msg)
            }
          })
          .catch(error => {
            this.notifyError('Registration failed', error)
          })
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
/*算式验证码*/
.math-captcha {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.math-captcha .expression {
  flex: 1;
  height: 40px;
  line-height: 40px;
  background: #f0f2f5;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #3E8E5A;
  cursor: pointer;
  user-select: none;
}
.math-captcha .captcha-input {
  width: 100px;
}
.otp-tip {
  text-align: left;
  font-size: 12px;
  color: #909399;
  margin: 0 0 10px 0;
}
</style>
